export default __webpack_public_path__ + "media/music/2019cc8f2afc1ceae50ba50f88151891.mp3";